import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=314a34da"
import script from "./GroupHeader.vue?vue&type=script&lang=ts"
export * from "./GroupHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('314a34da')) {
      api.createRecord('314a34da', component.options)
    } else {
      api.reload('314a34da', component.options)
    }
    module.hot.accept("./GroupHeader.vue?vue&type=template&id=314a34da", function () {
      api.rerender('314a34da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/teams/GroupHeader.vue"
export default component.exports